import classnames from "classnames";
import React from "react";

import "./hamburger.scss";

export type HamburgerProps = {
    active: boolean;
    handleClick: () => void;
};

const Hamburger = ({ active, handleClick }: HamburgerProps) => (
    <div
        onClick={() => handleClick()}
        className={classnames("hamburger", active && "hamburger--active")}
    >
        <div
            className={classnames(
                "hamburger__inner",
                active && "hamburger__inner--active",
            )}
        />
    </div>
);

export default Hamburger;
